import { render } from "./UserSpaces.vue?vue&type=template&id=26fad1eb&scoped=true"
import script from "./UserSpaces.vue?vue&type=script&lang=js"
export * from "./UserSpaces.vue?vue&type=script&lang=js"

import "./UserSpaces.vue?vue&type=style&index=0&id=26fad1eb&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26fad1eb"]])

export default __exports__